import React from "react";
import {Route, Routes} from "react-router-dom";

import {NotFound} from "./not-found";
import {WelcomeSplash} from "./welcome-splash";
import {SessionExpired} from "./session-expired";
import {AppStore} from "./app-store";


export const Welcome = () => {
    return (
        <div className="page-layout">
            <div className="page-layout__content">
                <Routes>
                    <Route path="/" element={<WelcomeSplash/>}/>
                    <Route
                        path="/app-store"
                        element={<AppStore/>}/>
                    <Route path="/session-expired" element={<SessionExpired/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Routes>
            </div>
        </div>
    );
};
